import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/auth';
import logo from '../../assets/logo.jpg';
import PublicShell from '../../components/PublicShell/PublicShell';
import './Register.css';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validaciones
    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    if (formData.password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      setLoading(false);
      return;
    }

    try {
      await authService.register(formData.email, formData.password, formData.username);
      
      // Redirigir a confirmación de email
      navigate('/confirm-email', { 
        state: { email: formData.email } 
      });
      
    } catch (err) {
      console.error('Error en registro:', err);
      
      let errorMessage = 'Error al crear la cuenta';
      
      if (err.code === 'UsernameExistsException') {
        errorMessage = 'Este email ya está registrado';
      } else if (err.code === 'InvalidPasswordException') {
        errorMessage = 'La contraseña no cumple los requisitos. Debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número';
      } else if (err.code === 'InvalidParameterException') {
        errorMessage = 'Email inválido';
      } else if (err.message) {
        errorMessage = err.message;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicShell>
      <div className="register-container">
      <div className="register-card">
        <div className="register-header">
          <div className="logo-container">
            <img src={logo} alt="Nissa Guard" className="logo-image" />
          </div>
          <h1>Crear Cuenta</h1>
          <p>Nissa Guard - Sistema de Monitoreo de Agua</p>
        </div>

        <form onSubmit={handleSubmit} className="register-form">
          <div className="form-group">
            <label htmlFor="username">Nombre de Usuario</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Tu nombre"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="tu@email.com"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Mínimo 8 caracteres"
              required
              minLength="8"
              disabled={loading}
            />
            <small className="form-hint">
              La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirmar Contraseña</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Confirma tu contraseña"
              required
              disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Creando cuenta...' : 'Crear Cuenta'}
          </button>

          <div className="register-footer">
            <p>
              ¿Ya tienes cuenta? <a href="/login">Inicia sesión aquí</a>
            </p>
          </div>
        </form>
      </div>
      </div>
    </PublicShell>
  );
};

export default Register;
